export default __webpack_public_path__ + "static/media/lucedelmare2.d02087d1.jpg";